import React from 'react';

import LinkRounded from '@mui/icons-material/LinkRounded';
import { Skeleton, Stack } from '@mui/material';

import ContentCard from '../../../../components/ContentCard';
import CopyButton from '../../../../components/CopyButton';
import { Exam } from '../../../../services/exams/types';

interface ActionsCardProps {
  exam?: Exam
}

const ActionsCard = ({ exam }: ActionsCardProps) => {
  if (!exam) {
    return (
      <Skeleton variant="rectangular" height={128} />
    );
  }

  return (
    <ContentCard variant="outlined" title="Actions">
      <Stack direction="row" spacing={1}>
        <CopyButton
          size="medium"
          copyText={`${window.location.origin}/exams?subject=${exam.subject}&examId=${exam.examId}`}
          startIcon={(<LinkRounded />)}
          buttonLabel="Copy Exam Link"
        />
      </Stack>
    </ContentCard>
  );
};

export default ActionsCard;
